import { template } from 'lodash';

const selectReferralComparisonTitle = (
  fullName,
  {
    referredUserPageTitle,
    referredNoNamePageTitle,
  },
) => {
  if (!fullName) return referredNoNamePageTitle;

  return template(referredUserPageTitle)({
    name: fullName,
  });
};

export default selectReferralComparisonTitle;
